import type { AttributesAlertProps } from '#lib/components/Attributes.types.js';
import type { TIdentify, TPrioritize, TInterventionsSignage } from './columns';
import { EIdentify, EPrioritize } from './interfaces';

const WARNINGS: Record<string, AttributesAlertProps> = {
	speedlimit: {
		contentHtml:
			'Posted speed limit data not available, statutory/default speed limit has been applied.',
		variant: 'warning'
	},
	radius: {
		contentHtml:
			'Low confidence in curve radius. Check other sources and use SafeCurves Identify Whitepaper to understand curve context changes.',
		variant: 'danger'
	},
	geometry: {
		contentHtml:
			'Low confidence in curve location, curve radius may be inaccurate. Check other sources and use SafeCurves Identify Whitepaper to understand curve context changes.',
		variant: 'warning'
	},
	speedmodel: {
		contentHtml:
			'This curve is too close to an intersection, vehicle approach speed is below curve context classification threshold.',
		variant: 'info'
	}
};
const IDENTIFY_ONLY = new Set(['radius', 'geometry', 'speedmodel']);

export const getAccuracyWarnings = (
	systemId: EIdentify | EPrioritize,
	attrs: TIdentify | TPrioritize | TInterventionsSignage
): (AttributesAlertProps | undefined)[] => {
	if (!attrs?.accuracy_warning) return [];
	// accuracy_warning is a comma-separated list, e.g. "speedlimit,radius,trafficvolume".
	const warnings = new Set(attrs.accuracy_warning.split(',').map((w) => w.trim().toLowerCase()));
	return [...warnings].map((w) =>
		IDENTIFY_ONLY.has(w) && systemId !== EIdentify.Identify ? undefined : WARNINGS[w]
	);
};
